import React from 'react';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';

const ProgressBarContainer = styled.div`
  position: absolute;
  left: 10px;
  right: 10px;
  z-index: 99;
  overflow: hidden;
  border-radius: 25px;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0px 2px 6px rgb(0 0 0 / 30%);
`;

const ProgressBar = styled.div<{ progress: number, fontColor: string, bgColor: string }>`
  margin-left: 0 !important;
  padding: 5px 10px !important;
  text-align: center;
  border-radius: 5px;
  display: block;
  white-space: nowrap;
  color: ${({ fontColor }) => fontColor};
  background: ${({ bgColor }) => bgColor};
  width: ${({ progress }) => `${Math.floor(progress * 100)}%`};
`;

export interface UploadProgressBarProps {
  visible: boolean;
  progress?: number;
  text?: string;
}

export const UploadProgressBar = ({ visible, progress, text }: UploadProgressBarProps) => (
  <CSSTransition in={visible} classNames="progressbar" timeout={{ appear: 0, enter: 300, exit: 300 }}>
    <ProgressBarContainer>
      {progress && (
        <ProgressBar
          progress={Math.abs(progress)}
          fontColor={progress > 0 ? 'white' : 'black'}
          bgColor={progress > 0 ? '#4eca82' : '#fea'}
        >
          {text}
        </ProgressBar>
      )}
    </ProgressBarContainer>
  </CSSTransition>
);
